<template>
  <svg
    version="1.1"
    id="Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 240.2 226.7"
    style="enable-background:new 0 0 240.2 226.7;"
    xml:space="preserve"
    class="lines_svg"
  >
    <title>{{$t('titles.polygon')}}</title>
    <rect class="lines_tool" width="240.2" height="226.7"></rect>
    <linearGradient
      id="SVGID_lines"
      gradientUnits="userSpaceOnUse"
      x1="58.16"
      y1="-1410.5314"
      x2="207.3407"
      y2="-1410.5314"
      gradientTransform="matrix(1 0 0 -1 0 -1300.1599)"
    >
      <stop offset="0" style="stop-color:#F4EA09"></stop>
      <stop offset="1" style="stop-color:#DA5D27"></stop>
    </linearGradient>
    <polygon
      class="lines_tool_1"
      points="126.6,114 202.4,157.8 138.9,195.8 60.7,150.6 60.7,66.4 126.6,26.4 "
    ></polygon>
  </svg>
</template>
<script>
export default {
  name: "linesTool"
};
</script>


<style>
.lines_tool {
  fill: #252624;
}
.lines_tool_1 {
  fill: none;
  stroke: url(#SVGID_lines);
  stroke-width: 5;
  stroke-miterlimit: 10;
}

.lines_svg {
  position: absolute;
  background: transparent;
  width: 65px;
  height: 58px;
  top: -23.5px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  margin-left: 136px;
}
</style>
